import {
  Box,
  type SxProps,
  Typography,
  type TypographyPropsVariantOverrides,
  type TypographyVariant
} from '@mui/material'
import type { OverridableStringUnion } from '@mui/types'
import type { SvgIconComponent } from '@mui/icons-material'
import { ContainedIcon } from '@/components/ContainedIcon/ContainedIcon.tsx'

export interface CardTitleProps {
  text: string
  icon?: SvgIconComponent
  titleType?: 'normal' | 'figure'
  sx?: SxProps
  secondaryText?: string
}

export function CardTitle({ text, titleType, icon, sx, secondaryText }: CardTitleProps) {
  let textVariant: OverridableStringUnion<
    TypographyVariant | 'inherit',
    TypographyPropsVariantOverrides
  >
  let spacing: number

  switch (titleType) {
    case 'figure':
      textVariant = 'hFigureCard'
      spacing = 3
      break
    default:
      textVariant = 'hCard'
      spacing = 1.5
  }

  return (
    <Box sx={{ ...sx, display: 'flex', flexDirection: 'column' }}>
      {icon ? <ContainedIcon variant="info" sx={{ mb: spacing }} icon={icon} /> : ''}

      <Typography color="primary" variant={textVariant} sx={{ letterSpacing: '0.24px' }}>
        {text}
      </Typography>
      {secondaryText && (
        <Typography color="grey.700" variant="body2" sx={{ mt: 0.5 }}>
          {secondaryText}
        </Typography>
      )}
    </Box>
  )
}
